import { useState, useEffect, useCallback } from 'react';
import { useHistory, Prompt } from 'react-router-dom';
import { UseFormReturn } from 'react-hook-form';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { RepQuoteFormState } from 'shared/types';

interface LeaveFormDialogProps {
  when: boolean;
  methods: UseFormReturn<RepQuoteFormState>;
  onSubmit: (data: RepQuoteFormState) => Promise<void>;
}

export const LeaveFormDialog = ({ when, methods: { handleSubmit, setValue }, onSubmit }: LeaveFormDialogProps) => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [lastLocation, setLastLocation] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with your navigate function
      history.push(lastLocation.pathname);
    }
  }, [confirmedNavigation, lastLocation, history]);

  const handleBlockedNavigation = useCallback(
    (location: any) => {
      if (!confirmedNavigation && when && location.pathname === '/quoting') {
        setIsOpen(true);
        setLastLocation(location);
        return false;
      }
      return true;
    },
    [confirmedNavigation, when, setIsOpen, setLastLocation]
  );

  const onClose = useCallback(() => {
    setIsOpen(false);
    setConfirmedNavigation(true);
  }, [setIsOpen, setConfirmedNavigation]);

  const onConfirm = useCallback(
    (e: React.MouseEvent) => {
      setValue('status', 'DRAFT');
      setIsOpen(false);
      handleSubmit(onSubmit)(e);
    },
    [setValue, setIsOpen, handleSubmit, onSubmit]
  );

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />
      <Dialog open={isOpen} onClose={onClose} fullWidth={true} aria-labelledby='leave-dialog'>
        <DialogTitle id='leave-dialog-title'>Do you want to save as draft ?</DialogTitle>
        <DialogActions>
          <Button onClick={onClose} color='primary'>
            No
          </Button>
          <Button color='primary' onClick={onConfirm}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
